module.exports = __webpack_public_path__ + "assets/img/5_1150.73cd5054.jpg";